import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "wSize"];
import { ConfigContext, Layout } from "@pionex-web-kit/components";
import cns from "classnames";
import React, { useContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function BasicContent(_ref) {
  var className = _ref.className,
    wSize = _ref.wSize,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("basic-layout-content");
  return /*#__PURE__*/_jsx(Layout.Content, _objectSpread({
    className: cns(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-sm"), wSize === "small"))
  }, props));
}